import React, { useState } from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  SelectChangeEvent,
} from "@mui/material";

interface PlotSwitcherProps {
  switching: (plot: string) => void;
}

export const PlotSwitcher: React.FC<PlotSwitcherProps> = ({ switching }) => {
  const [selectedPlot, setSelectedPlot] = useState<string>("SessionPlot");

  const handleChange = (event: SelectChangeEvent<string>) => {
    switching(event.target.value);
    setSelectedPlot(event.target.value);
  };

  return (
    // <Grid container spacing={3}>
    //   <Grid item xs={6}>
    <div>
      {/* <Paper style={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}> */}
      <FormControl>
        <InputLabel id="plot-select-label">Select Plot</InputLabel>
        <Select
          labelId="plot-select-label"
          id="plot-select"
          value={selectedPlot}
          onChange={handleChange}
        >
          <MenuItem value="SessionPlot">Session Plot</MenuItem>
          <MenuItem value="CumUserLoginPlot">User Login Plot</MenuItem>
          <MenuItem value="UserTimePlot">User Druation Plot</MenuItem>
          <MenuItem value="CumTopAction1Plot">Top Action Plot</MenuItem>
          <MenuItem value="CumCodeRelatedPlot">
            Code Related Action Plot
          </MenuItem>
          <MenuItem value="SinglePDFWatchTime">Single PDF Watch Time</MenuItem>
          <MenuItem value="PDFTypeWatchTime">PDF Type Watch Time</MenuItem>
        </Select>
      </FormControl>
      {/* </Paper> */}
      {/* </Grid>

    </Grid> */}
    </div>
  );
};

export default PlotSwitcher;
